import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./Pages/Shared/Navigation/Navigation";
import Home from "./Pages/Home/Home/Home";
import Footer from "./Pages/Shared/Footer/Footer";
import Contact from "./Pages/Home/Contact/Contact";
import AllProjects from "./Pages/Home/Projects/AllProjects";
import Loader from "react-loader-spinner";
import { useEffect, useState } from "react";
import ProjectDetails from "./Pages/Home/Projects/ProjectDetails";
import Blogs from "./Pages/Home/Blogs/Blogs";
import About from "./Pages/Home/About/About";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app">
      {!loading && (
        <Router>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/allProjects" element={<AllProjects />} />
            <Route path="/Blogs" element={<Blogs />} />
            <Route
              path="/projectDetails/:projectId"
              element={<ProjectDetails />}
            ></Route>
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer></Footer>
        </Router>
      )}
      {loading && (
        <div
          className="text-center"
          style={{ backgroundColor: "black", height: "100vh" }}
        >
          <Loader
            type="Bars"
            color="#dc3545"
            height={500}
            width={100}
            timeout={3000} //3 secs
          />
        </div>
      )}
    </div>
  );
}

export default App;
